export const INITIAL_PLAN_WEEKLY_SPEND = 'initial_plan_weekly_spend';
export const INITIAL_PLAN_MONTHLY_SPEND = 'initial_plan_monthly_spend';
export const INITIAL_PLAN_WEEKLY_HEADERS = 'initial_plan_column_headers_weekly';
export const INITIAL_PLAN_DOWNLOAD_FILE_WEEKLY = 'initial_plan_spend_weekly.xlsx';
export const INITIAL_PLAN_DOWNLOAD_FILE_MONTHLY = 'initial_plan_spend_monthly.xlsx';
